import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faFacebookF,
  faTwitter,
  faInstagram,
  faLinkedinIn,
  faPinterestP,
  faYoutube,
} from "@fortawesome/free-brands-svg-icons";
import {
  faLocationDot,
  faPhone,
  faEnvelope,
} from "@fortawesome/free-solid-svg-icons";
import "./Footer.css";

function Footer() {
  return (
    <footer className="footer-container">
      <div className="footer-content">
        {/* Logo and Address */}
        <div className="footer-logo-section">
          <h2>Apco Lighting</h2>
          <p>Innovative Lighting Solutions</p>
          <address>
            <FontAwesomeIcon icon={faLocationDot} className="icon" /> Janki
            Pada, Vasai East, Palghar, 401208
          </address>
        </div>

        {/* Contact Information */}
        <div className="footer-contact-section">
          <p>
            <a href="tel:+91777509122" className="contact-link">
              <FontAwesomeIcon icon={faPhone} className="icon" /> +91 777509122
            </a>
          </p>
          <p>
            <a href="mailto:apcolighting@gmail.com" className="contact-link">
              <FontAwesomeIcon icon={faEnvelope} className="icon" />{" "}
              apcolighting@gmail.com
            </a>
          </p>

          {/* <div className="business-icons">
            <a href="https://www.justdial.com" target="_blank" rel="noopener noreferrer">
              <img src="images/socialmedia/justdial-icon.png" alt="Just Dial" className="business-icon" />
            </a>
            <a href="https://www.indiamart.com" target="_blank" rel="noopener noreferrer">
              <img src="/images/socialmedia/indiamart-icon.png" alt="IndiaMart" className="business-icon" />
            </a>
          </div> */}

        </div>

        {/* Social Media Links */}
        <div className="footer-social-section">
          <p>Connect with us</p>
          <div className="social-icons">
            <a
              href="https://www.linkedin.com/in/apco-light-industries-18850a21a/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <FontAwesomeIcon icon={faLinkedinIn} />
            </a>
            <a
              href="https://www.facebook.com/profile.php?id=100064010050963"
              target="_blank"
              rel="noopener noreferrer"
            >
              <FontAwesomeIcon icon={faFacebookF} />
            </a>
            {/* <a
              href="https://twitter.com"
              target="_blank"
              rel="noopener noreferrer"
            >
              <FontAwesomeIcon icon={faTwitter} />
            </a> */}
            <a
              href="https://www.instagram.com/apcoliteindustries?igsh=MTF5OGYyajdveGQwaA=="
              target="_blank"
              rel="noopener noreferrer"
            >
              <FontAwesomeIcon icon={faInstagram} />
            </a>
            {/* <a
              href="https://pinterest.com"
              target="_blank"
              rel="noopener noreferrer"
            >
              <FontAwesomeIcon icon={faPinterestP} />
            </a>
            <a
              href="https://youtube.com"
              target="_blank"
              rel="noopener noreferrer"
            >
              <FontAwesomeIcon icon={faYoutube} />
            </a> */}
          </div>
        </div>
      </div>

      {/* Footer Bottom */}
      <div className="footer-bottom">
        <p>
          &copy; {new Date().getFullYear()} Apco Lighting. All rights reserved.
        </p>
      </div>
    </footer>
  );
}

export default Footer;
